// prop-types is library for typechecking of props
import PropTypes from "prop-types";

// @mui material components
import Card from "@mui/material/Card";
import Divider from "@mui/material/Divider";
import { Icon } from "@iconify/react";

import Switch from "@mui/material/Switch";

// Trakib components
import MDBox from "components/MDBox";
import MDTypography from "components/MDTypography";
import MDAvatar from "components/MDAvatar";
import MDButton from "components/MDButton";

// import * as GiIcons from "react-icons/gi";
// import * as MdIcons from "react-icons/md";
// import * as FaIcons from "react-icons/fa";
// import * as BiIcons from "react-icons/bi";
import MDInput from "components/MDInput";
import HtmlContent from "components/HtmlContent";

// const ICON_LIBRARIES = {
//   GI: GiIcons,
//   MD: MdIcons,
//   FA: FaIcons,
//   BI: BiIcons,
// };

// Custom styles for ComplexProjectCard
function ComplexProjectCard({
  color,
  image,
  title,
  description,
  members,
  dropdown,
  isIcon,
  icon_name,
  order,
  isVisible,
  visibleOption,
  setVisible,
  setOrder,
}) {
  // Fixed getIconComponent function
  // const getIconComponent = (iconName) => {
  //   if (!iconName) return null;

  //   // Extract prefix (first 2 characters) and convert to uppercase
  //   const prefix = iconName.substring(0, 2).toUpperCase();
  //   const IconComponent = ICON_LIBRARIES[prefix]?.[iconName];
  //   return IconComponent ? <IconComponent size="60" /> : null;
  // };

  const renderMembers = members.map((member, key) => {
    const memberKey = `member-${key}`;
    let x;
    if (member.type === "icon")
      x = (
        <MDAvatar
          key={memberKey}
          alt="member profile"
          size="xs"
          bgColor={"secondary"}
          sx={({ borders: { borderWidth }, palette: { white } }) => ({
            border: `${borderWidth[2]} solid ${white.main}`,
            cursor: "pointer",
            position: "relative",
            "&:not(:first-of-type)": {
              ml: -1.25,
            },

            "&:hover, &:focus": {
              zIndex: "10",
            },
          })}
        >
          {/* {getIconComponent(member.iconName || "GiWaterDrop")} */}
          <Icon icon={member.iconName} width={32} height={32} />
        </MDAvatar>
      );
    else if (member.type === "image")
      x = (
        <MDAvatar
          key={memberKey}
          src={member.src}
          alt="member profile"
          size="xs"
          sx={({ borders: { borderWidth }, palette: { white } }) => ({
            border: `${borderWidth[2]} solid ${white.main}`,
            cursor: "pointer",
            position: "relative",

            "&:not(:first-of-type)": {
              ml: -1.25,
            },

            "&:hover, &:focus": {
              zIndex: "10",
            },
          })}
        />
      );
    return x;
  });

  const handleSetVisible = () => setVisible(!isVisible);
  const handleChangeOrder = (o) => setOrder(o.target.value);

  return (
    <Card>
      <MDBox p={2}>
        <MDBox display="flex" alignItems="center">
          <MDAvatar
            src={isIcon ? null : image}
            alt={title}
            size="xl"
            variant="rounded"
            bgColor={color}
            sx={{
              p: isIcon ? 1 : 0,
              mt: -6,
              borderRadius: ({ borders: { borderRadius } }) => borderRadius.xl,
            }}
          >
            {/* {isIcon ? getIconComponent(icon_name || "GiWaterDrop") : null} */}
            {isIcon ? <Icon icon={icon_name} width={32} height={32} /> : null}
          </MDAvatar>
          <MDBox ml={2} mt={-2} lineHeight={0}>
            <MDTypography
              variant="overline"
              textTransform="capitalize"
              fontWeight="bold"
            >
              {title}
            </MDTypography>
            {members.length > -1 ? (
              <MDBox display="flex">{renderMembers}</MDBox>
            ) : null}
          </MDBox>
          {dropdown && (
            <MDTypography
              color="secondary"
              onClick={dropdown.action}
              sx={{
                ml: "auto",
                mt: -1,
                alignSelf: "flex-start",
                py: 1.25,
              }}
            >
              {/* <Icon
                fontSize="default"
                sx={{ cursor: "pointer", fontWeight: "bold" }}
              >
                more_vert
              </Icon> */}
              <Icon
                sx={{ cursor: "pointer", fontWeight: "bold" }}
                icon="mdi:dots-vertical"
                width={32}
                height={32}
              />
            </MDTypography>
          )}
          {dropdown.menu}
        </MDBox>
        {description && (
          <>
            <MDBox my={2} lineHeight={1}>
              <MDBox
                sx={{
                  cursor: "pointer",
                  maxHeight: 200,
                  overflowY: "auto",
                  maxWidth: 500,
                }}
              >
                <HtmlContent html={description} />
              </MDBox>
            </MDBox>
            <Divider />
          </>
        )}

        {(order || visibleOption) && (
          <MDBox
            display="flex"
            justifyContent="space-between"
            alignItems="center"
          >
            {order && (
              <MDBox display="flex" flexDirection="column" lineHeight={0}>
                <MDInput
                  variant="standard"
                  type="number"
                  label="الترتيب"
                  value={order}
                  onChange={handleChangeOrder}
                />
              </MDBox>
            )}
            {visibleOption && (
              <MDBox
                display="flex"
                flexDirection="column"
                lineHeight={0}
                alignItems="center"
              >
                <MDTypography variant="caption" fontWeight="regular">
                  {isVisible ? "إخفاء" : "عرض"}
                </MDTypography>
                <MDBox>
                  <Switch checked={isVisible} onChange={handleSetVisible} />
                </MDBox>
              </MDBox>
            )}
          </MDBox>
        )}
      </MDBox>
    </Card>
  );
}

// Setting default values for the props of ComplexProjectCard
ComplexProjectCard.defaultProps = {
  color: "dark",
  dateTime: "",
  members: [],
  dropdown: false,
};

// Typechecking props for the ProfileInfoCard
ComplexProjectCard.propTypes = {
  color: PropTypes.oneOf([
    "primary",
    "secondary",
    "info",
    "success",
    "warning",
    "error",
    "dark",
    "light",
  ]),
  image: PropTypes.string,
  title: PropTypes.string.isRequired,
  dateTime: PropTypes.string,
  description: PropTypes.node,
  members: PropTypes.arrayOf(PropTypes.any),
  dropdown: PropTypes.oneOfType([
    PropTypes.bool,
    PropTypes.shape({
      action: PropTypes.func,
      menu: PropTypes.node,
    }),
  ]),
};

export default ComplexProjectCard;
